<div [formGroup]="form">
  <div class="input-panel">
    <div class="input-label">{{ 'forms.profileDetails.occupationType' | translate }}*</div>
    <div class="input-field">
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="occupationType"
        (selectionChange)="
          changeValidity(form.value.occupationType == othersId, 'othersOccupationType')
        "
      >
        <mat-option *ngFor="let type of occupationType" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
      <ng-container *ngIf="form.value.occupationType == othersId">
        <input
          class="form-control mt-2"
          formControlName="othersOccupationType"
          type="text"
          placeholder="{{ 'common.pleaseSpecify' | translate }}"
          maxlength="512"
        />
        <app-validation-error-message
          [inputName]="'forms.profileDetails.othersOccupationType' | translate"
          [showFormError]="showFormError"
          [control]="form.get('othersOccupationType')"
        >
        </app-validation-error-message>
      </ng-container>
    </div>
    <app-validation-error-message
      [inputName]="'profile.employmentStatusInput' | translate"
      [showFormError]="showFormError"
      [control]="form.get('occupationType')"
    >
    </app-validation-error-message>
  </div>
  <div class="input-panel">
    <div class="input-label">{{ 'forms.profileDetails.employmentSector' | translate }}*</div>
    <div class="input-field">
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="employmentSector"
      >
        <mat-option *ngFor="let type of employmentSectors" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
    </div>
    <app-validation-error-message
      [inputName]="'forms.profileDetails.employmentSector' | translate"
      [showFormError]="showFormError"
      [control]="form.get('employmentSector')"
    >
    </app-validation-error-message>
  </div>
</div>
